import { createContext } from 'react';

import { bluestar } from '@tanium/theme-data';

import { ThemeContextType } from './types';

const ThemeContext = createContext<ThemeContextType>({ theme: bluestar });

export default ThemeContext;
